<template>
  <span class="submit-button-guard">
    <slot :disabled="isActive" />
    <q-icon v-if="isActive" name="warning" color="warning" size="sm">
      <q-tooltip>{{ tooltipText }}</q-tooltip>
    </q-icon>
  </span>
</template>

<script setup>
import { computed } from "vue"

import { useGlobalStore } from "@/stores/global.js"

import * as datesService from "@/services/dates.js"

import i18n from "@/plugins/i18n.js"

const globalStore = useGlobalStore()

const isActive = computed(() => {
  const settings = globalStore.globalSettings
  if (!settings.requestSubmissionMaintenanceEnabled) {
    return false
  }

  const start = datesService.parseUtcString(settings.requestSubmissionMaintenanceStartUtc)
  const end = datesService.parseUtcString(settings.requestSubmissionMaintenanceEndUtc)

  if (!start && !end) {
    return true
  }

  const now = new Date()
  return (!start || now >= start) && (!end || now <= end)
})

const tooltipText = computed(() => {
  const settings = globalStore.globalSettings
  const start = datesService.parseUtcString(settings.requestSubmissionMaintenanceStartUtc)
  const end = datesService.parseUtcString(settings.requestSubmissionMaintenanceEndUtc)

  if (start && end) {
    return i18n.global.t("_RSFAP_SHARED_SUBMISSION_MAINTENANCE_SUSPENDED_FROM_TO", [start.toLocaleString(), end.toLocaleString()])
  }

  return i18n.global.t("_RSFAP_SHARED_SUBMISSION_MAINTENANCE_SUSPENDED")
})
</script>

<style scoped>
.submit-button-guard {
  display: inline-flex;
  align-items: center;
  gap: 4px;
}
</style>
